// extracted by mini-css-extract-plugin
module.exports = {"Base__Breadcrumbs":"Base_Base__Breadcrumbs__3ABis","Base__Document":"Base_Base__Document__CXt52","Base__Footer":"Base_Base__Footer__2hTgB"};